import React, { useEffect } from "react";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { FormattedMessage, useIntl } from "react-intl";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant.js";
import { useSelector } from "react-redux";
import "./../subscribeForm/subscribeForm.scss";
import ContentLoading from "component/LoadingComponent/ContentLoading.js";
import MainDepartment from "component/shared/main-department/MainDepartment.jsx";
import { useParams } from "react-router-dom";
import { LabelLangString } from "component/LabelLang/label-lang.js";
import HtmlView from "component/htmlView/html-view.js";
import AboutDepartment from "component/shared/about-department/AboutDepartment.jsx";
import ReactGA from "react-ga4";

function ServiceDetails() {
  const intl = useIntl();

  // const dir = useSelector(({ theme }) => theme.direction);

  const currentLocale = useSelector(({ theme }) => theme.locale);

  const { id } = useParams();

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, [id]);

  const getServices = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS}/${id}`,
  });

  const getDepartment = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS_DEPARTMENT}=${id}`,
  });

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: `/servicestools/${id}`,
      title: `Service: ${getServices?.data?.data?.title}`,
    });
  }, [id]);

  return (
    <ContentLoading
      isLoading={getDepartment.isLoading || getServices.isLoading}
    >
      <div className="service-tools-details">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "service-tools" }),
              clickClass: false,
            },
            {
              title: LabelLangString({
                id: "title",
                currentLocale: currentLocale,
                defaultValue: getServices?.data?.data?.title,
                translations:
                  getServices?.data?.data?.serviceAndToolTranslation,
              }),
              clickClass: true,
            },
          ]}
          title={LabelLangString({
            id: "title",
            currentLocale: currentLocale,
            defaultValue: getServices?.data?.data?.title,
            translations: getServices?.data?.data?.serviceAndToolTranslation,
          })}
          route={"../servicestools"}
        />

        <div className="container py-5">
          <div className="row">
            <div className="col-lg-8">
              <div className="service-content">
                {getServices?.data?.data?.content !== null &&
                getServices?.data?.data?.content !== undefined ? (
                  <HtmlView
                    html={LabelLangString({
                      id: "content",
                      currentLocale: currentLocale,
                      defaultValue: getServices?.data?.data?.content,
                      translations:
                        getServices?.data?.data?.serviceAndToolTranslation,
                    })}
                  />
                ) : (
                  <FormattedMessage id="data-not-found" />
                )}
              </div>
            </div>

            <div className="col-lg-4">
              <AboutDepartment
                id={"about"}
                txt={getServices?.data?.data?.about}
                translations={
                  getServices?.data?.data?.serviceAndToolTranslation
                }
              />
              <div className="mt-4">
                <MainDepartment getDepartment={getDepartment} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default ServiceDetails;
